import React from 'react';
import _ from 'lodash';
import { Checkbox, FormControl, FormControlLabel, FormGroup, FormHelperText } from '@material-ui/core';

const FormikCheckBox = ({ field: { ...fields }, form: { touched, errors }, ...props }): React.ReactNode => {
    const { label, checkedIcon, icon, ...rest } = props;
    const error = Boolean(_.get(touched, fields.name) && _.get(errors, fields.name));

    return (
        <FormControl error={error} disabled={props.disabled}>
            <FormGroup>
                <FormControlLabel
                    label={label}
                    control={
                        <Checkbox
                            {...fields}
                            {...rest}
                            className="custom-checkbox"
                            checkedIcon={checkedIcon}
                            icon={icon}
                            checked={fields.value}
                        />
                    }
                />
            </FormGroup>
            {error && <FormHelperText error>{error && errors[fields.name]}</FormHelperText>}
        </FormControl>
    );
};
export default FormikCheckBox;
